import React from 'react';
import { CircularLoader } from './CircularLoader';

interface IButtonProps {
  onClick?: () => void;
  label?: any;
  color?: string;
  textColor?: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  fullWidth?: boolean;
  ariaLabel?: string;
}

export const Button = (props: IButtonProps) => {
  const {
    color,
    textColor,
    onClick,
    label,
    icon,
    style,
    type,
    disabled,
    loading,
    fullWidth,
    ariaLabel,
  } = props;
  return (
    <button
      style={{ backgroundColor: color || '#FF6F61', color: textColor, ...style }}
      disabled={disabled || false}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-busy={loading || undefined}
      className={`min-h-[48px] h-12 px-5 md:px-12 rounded-md text-white font-sans font-normal md:font-bold flex items-center justify-center gap-[8px] whitespace-nowrap transition-opacity hover:opacity-85 active:opacity-70 disabled:opacity-50 disabled:cursor-not-allowed w-full ${
        fullWidth ? 'md:w-auto' : 'md:w-fit'
      }`}
      type={type || 'button'}
    >
      {label}
      {icon && icon}
      {loading && <CircularLoader />}
    </button>
  );
};
